export default {
  title: 'Inicia sesión en tu propia dirección',
  description:
    'Esta dirección pertenece a un partner del que tu cuenta no forma parte. Para mantener tu cuenta segura, inicia sesión donde lo haces habitualmente: tu correo y tu contraseña funcionan allí.',
  continue: 'Continuar a {{host}}',
  password_changed: 'Tu contraseña se ha cambiado.',
};
